import {
  AppBar, Avatar, Badge, Box, Divider, Fade, Grid, IconButton, InputBase,
  ListItemIcon, Menu, MenuItem, Stack, Toolbar, Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  CalendarMonth, Email, KeySharp, Logout, MenuOpen, Notifications,
  NotificationsNone, Person, Search, Settings, Storefront,
} from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Link, useNavigate } from "react-router-dom";
import {
  getLocalValue,
  LoacalVariables,
} from "../../commonFunctions/CommonFunctions";
import LabelDisplay from "../../FrontEnd/UpdateChange/LabelDisplay";
import logo from '../../images/melp-logo-2.svg'
import WSCustomBreadcrumbs from "../BreadCrumbs/BreadCrumbsComp";
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import { WSIcons } from "../../commonFunctions/iIcons";

// import logo from "../../images/logo.png";
interface NavbarProps {
  collapse: boolean;
  drawerWidth?: number;
  handleCollapse: () => void;
  anchorEl: null | HTMLElement;
  badgeContent?: number;
  position?: "fixed" | "absolute" | "relative" | "static" | "sticky";
  backgroundColor?: string;
  iconColor?: string;
  height?: string;
}

const Navbar2: React.FC<NavbarProps> = ({
  collapse,
  drawerWidth = 240,
  handleCollapse,
  badgeContent = 0,
  backgroundColor = "#ffffff",
  iconColor = "#4a4b77",
}) => {
  const [profileAnchor, setProfileAnchor] = useState<null | HTMLElement>(null);
  const openProfileMenu = (event: React.MouseEvent<HTMLElement>) =>
    setProfileAnchor(event.currentTarget);
  const closeProfileMenu = () => setProfileAnchor(null);
  const navigate = useNavigate()
  // State for Notifications Menu
  const [notificationAnchor, setNotificationAnchor] =
    useState<null | HTMLElement>(null);
  const openNotificationMenu = (event: React.MouseEvent<HTMLElement>) =>
    setNotificationAnchor(event.currentTarget);
  const closeNotificationMenu = () => setNotificationAnchor(null);
  const [notifAnchor, setNotifAnchor] = useState<null | HTMLElement>(null);
  return (
    <AppBar
      elevation={0}
      position="fixed"
      color="inherit"
      sx={{
        width: "100%",
        mt: 1,
        border: "1px solid #e3e3e3",
        borderRadius: 8, // Optional: if you don’t want rounded corners
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}    >
      <Grid item container spacing={0} >
        <Grid item sm={12}>
          <Toolbar sx={{ minHeight: 64, marginLeft: 0 }}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              spacing={2}
            >
              <Grid item xs={12} sm={0.5} >
                <img src={logo} style={{ marginTop: -2, marginRight: 9, width: "7rem", height: "auto", border: "1px solid #098963", borderRadius: "24px" }}></img>
              </Grid>


              {/* greeting */}
              <Grid item xs={12} sm={7} sx={{ marginLeft: 10 }}>
                <LabelDisplay />

                <WSCustomBreadcrumbs />

              </Grid>
              <Grid item xs={12} sm={1.5} >

                <Stack direction="row" alignItems="ri" spacing={2}>
                  <Stack
                    direction="row"
                    alignItems="right"
                    spacing={1}
                    sx={{
                      px: 1,
                      pl: 2,
                      py: 0.9,
                      border: "1px solid #098963",
                      borderRadius: 8,
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => setProfileAnchor(e.currentTarget)} // <-- Add this

                  >
                    <Avatar sx={{ width: 25, height: 25 }} />
                    <Typography sx={{ fontSize: '0.875rem' }}>{getLocalValue(LoacalVariables.Name)}</Typography>
                  </Stack>

                </Stack>
              </Grid>
            </Grid>
          </Toolbar>
        </Grid>
      </Grid>
      {/* menus */}
      <Menu
        anchorEl={profileAnchor}
        open={Boolean(profileAnchor)}
        onClose={() => setProfileAnchor(null)}
        TransitionComponent={Fade}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        PaperProps={{
          sx: {
            mt: 1.5,
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.15))",
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 18, // adjust arrow position
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
      >
        {/* <MenuItem
          sx={{ fontSize: "0.875rem", width: 150 }}
          onClick={() => {
            setProfileAnchor(null);
             navigate("/profile/view");
          }}
        >
          <WSIcons.Person sx={{ mr: 1, width: 20, height: 20 }} />
          Profile
        </MenuItem> */}
        {/* <Divider /> */}
        <MenuItem
          sx={{ fontSize: "0.875rem" }}
          onClick={() => {
            setProfileAnchor(null);
            navigate("/logOut");
          }}
        >
          <WSIcons.LogOut sx={{ mr: 1, color: "red", width: 20, height: 20 }} />
          Logout
        </MenuItem>
      </Menu>

    </AppBar>
  );
};

export default Navbar2;
